module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/ap_bubble-c74f0f46919d1d3423db70b5542d204c.png";